/* global axios */

// [xleaders] Không dùng ApiClient: route panel CRM nằm ngoài /api/v1
// (xem app/controllers/xleaders/crm_panel_controller.rb). `axios` đã có sẵn
// header devise-token-auth qua APIHelper nên gọi thẳng path là đủ.
const CRM_PANEL_BASE_PATH = '/xleaders/crm_panel';

export const extractCrmPersonInfo = (accountId, conversationDisplayId) => {
  return axios.post(
    `${CRM_PANEL_BASE_PATH}/extract?account_id=${accountId}&conversation_display_id=${conversationDisplayId}`
  );
};

export const applyCrmPersonExtraction = (
  accountId,
  conversationDisplayId,
  fields
) => {
  return axios.post(
    `${CRM_PANEL_BASE_PATH}/apply_extraction?account_id=${accountId}&conversation_display_id=${conversationDisplayId}`,
    { fields }
  );
};
